import {createSlice} from "@reduxjs/toolkit";

const dictaphoneSlice = createSlice({
    name: "dictaphone",
    initialState: {
        status: 0,
        globalCommands: [],
        commands: []
    },
    reducers:{
        startService: (state, action) => {
            if (state.status == 1)
                return state;
            
                return ({...state, status: 1});
        },
        stopService: (state, action) => {
            if (state.status == 0)
                return state;
            
                return ({...state, status: 0});
        },
        resetService: (state, action) => {
            return ({...state, status: -1})
        },
        toggleService: (state, action) => {
            if (state.status == 0)
                return ({...state, status: 1});
            else
                return ({...state, status: 0});
        }, 
        setStatus: (state, action) => ({...state, status: action.payload}),
        setGlobalCommands: (state, action) => {
            return ({...state, globalCommands: action.payload, commands: action.payload})
        },
        setPageCommands: (state, action) => ({...state, commands:[...state.globalCommands, ...action.payload]})
    }
});

export const { startService, stopService, resetService, toggleService, setStatus, setGlobalCommands, setPageCommands } = dictaphoneSlice.actions;

export default dictaphoneSlice.reducer;
